import React from "react";
import { ButtonFix } from "../../common";
import "./FormLayout.scss";

const FormLayout = props => <div className="FormLayout" {...props} />;

const Fieldset = ({ children, title }) => (
  <fieldset className="fieldset">
    <legend className="fieldset__label">{title}</legend>
    {children}
  </fieldset>
);

const RadioButtons = props => (
  <div className="fieldset__radio-list" {...props} />
);

const SubmitButton = ({ children }) => (
  <div className="text-center">
    <ButtonFix type="submit" buttoncolor="yellow" buttonsize="big">
      {children}
    </ButtonFix>
  </div>
);

const DetailedCheckboxes = props => (
  <div className="fieldset__detailed-checkboxes" {...props} />
);

FormLayout.Fieldset = Fieldset;
FormLayout.SubmitButton = SubmitButton;
FormLayout.RadioButtons = RadioButtons;
FormLayout.DetailedCheckboxes = DetailedCheckboxes;

export default FormLayout;
